import React from 'react';
import {Link, withRouter} from 'react-router-dom';

@withRouter
export default class Breadcrumbs extends React.Component {

  state = { show: false };

  componentWillMount(){
    this.handleRoute(this.props.location.pathname);
    this.listener = this.props.history.listen(location => {
      this.handleRoute(location.pathname);
    })
  }

  handleRoute = pathname => {
    if(!pathname.includes('tutorial') &&
      !pathname.includes('categories') &&
      pathname !== '/' &&
      !pathname.includes('dashboard'))
      this.setState({show: true});
    else
      this.setState({show: false});
  };

  componentWillUnmount(){
    this.listener();
  }

  render(){
    if(this.state.show)
      return(
        <ol className="breadcrumbs" style={{position: 'absolute', zIndex: 10}}>
          <li className="breadcrumb-item active">
            <Link to="/dashboard">Dashboard</Link>
          </li>
        </ol>
      );
    else
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/components/Breadcrumbs.js